import { WhaleZonesModelBase } from './whale-zones-model';
import { ZoneFeature, Zones } from './zones-base-interfaces';

export class WhaleZonesModelImpl extends WhaleZonesModelBase {
    constructor(geojson?: Zones) {
        super();

        if (geojson) {
            this._whaleZones = geojson;
        } else {
            this._loadingPromise = this._loadGeoJson();
            setInterval(() => this._loadGeoJson(), 60*60*1000); // refresh the list every 1h
        }
    }
    
    public async allZones(): Promise<ZoneFeature[] | null> {
        await this._loadingPromise;

        return this._whaleZones!.features;
    }

    public async allActiveZones(fromDate: Date, toDate: Date): Promise<ZoneFeature[] | null> {
        await this._loadingPromise;

        const activeZones: ZoneFeature[] = [];

        this._whaleZones!.features.forEach(f => {
            let from: Date;
            let to: Date;
            const fromYear = new Date(fromDate).getFullYear();
                
            if (f.properties.from!.startsWith("--") && f.properties.to!.startsWith("--")) {
                const fromText = f.properties.from!.replace("--", "").split("-");
                from = new Date(`${fromYear}-${fromText[0]}-${fromText[1]}T00:00:00.000Z`); 
                const toText = f.properties.to!.replace("--", "").split("-");
                to = new Date(`${fromYear}-${toText[0]}-${toText[1]}T00:00:00.000Z`); 
            } else {
                const parsedFrom = new Date(Date.parse(f.properties.from!));
                from = new Date(fromYear, parsedFrom.getUTCMonth(), parsedFrom.getUTCDate());
                const parsedTo = new Date(Date.parse(f.properties.to!));
                to = new Date(fromYear, parsedTo.getUTCMonth(), parsedTo.getUTCDate());
            }

            //adjusting 'to' if interval goes into next year
            const now = new Date()
            if (from > to && now > from){ 
                to.setFullYear(to.getFullYear() + 1);    
            }
            //adjusting 'from' if interval goes into previous year
            if (from > to && now < from){ 
                from.setFullYear(from.getFullYear() - 1);    
            }
            
            if ((toDate >= from && toDate <= to) || (fromDate >= from && fromDate <= to)){
                activeZones.push(f);
            }
        });
        
        return activeZones;
    }

    public formatFromTo(zone: ZoneFeature) {
        const months = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        let from: string = "";
        let to: string = "";

        if (zone.properties.from!.startsWith("--") && zone.properties.to!.startsWith("--")) {
            const fromText = zone.properties.from!.replace("--", "").split("-");
            const toText = zone.properties.to!.replace("--", "").split("-");
            const fromDay = parseInt(fromText[1]);
            const toDay = parseInt(toText[1]);
            const fromMonth = parseInt(fromText[0]);
            const toMonth = parseInt(toText[0]);
            
            from = `${months[fromMonth-1]} ${fromDay}`;
            to = `${months[toMonth-1]} ${toDay}`;
        } else {
            const fromDate = new Date(Date.parse(zone.properties.from!));
            const toDate = new Date(Date.parse(zone.properties.to!));
            from = `${months[fromDate.getUTCMonth()]} ${fromDate.getUTCDate()}`;
            to = `${months[toDate.getUTCMonth()]} ${toDate.getUTCDate()}`;
        }

        return `${from} - ${to}`;
    }

    private _whaleZones: Zones | null = null;
    private _loadingPromise: Promise<void> | null = null;

    private async _loadGeoJson() {
        const whaleZones : Zones = (await (await fetch("./dtnareas_whale.geojson")).json());
        if (whaleZones) {
            this._whaleZones = whaleZones;
        }
    }
}